<template>
    <section class="pages">
        <button v-if="currentPage > 1" @click="decPage()" class="pages__btn" > &#171; </button>
            <a
              v-for="(page, index) in totalPages" 
              :key="index" 
              v-text="page"
              :class="{ 'active': currentPage === page }"
              @click="$store.state.currentPage = page">
            </a>
        <button v-if="currentPage < totalPages.length" @click="incPage()" class="pages__btn" > &#187; </button>
    </section>
</template>

<script>
export default {
    computed: {
        totalPages() {
            return this.$store.state.totalPages;
        },
        currentPage() {
            return this.$store.state.currentPage;
        }
    },
    methods: {
        incPage() {
            this.$store.state.currentPage++; 
        },
        decPage() {
            this.$store.state.currentPage--;
        },
    },

}
</script>

<style lang="scss" scoped>
@import "../../scss/settings";

/* Ev flytta styling senare */

.pages {
    @include content-width;
    @extend %center-content;
    margin: 1rem auto;
    padding-bottom: .5rem;
    font-size: rem-calc(24);

    > a {
      border: 1px solid black;
      color: #313131;
      cursor: pointer;
    //   display: block;
      padding: .2rem .5rem; 
      text-decoration: none;
      transition: all .2s ease;

        &.active {
            padding: .2rem 1rem;
            color: white;
        }

    }

    &__btn {
        background: transparent;
        border: none;
    }
}


</style>